import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import Jumbotron from './images/domotica.jpg';

import './homeComponent.css';

export default class HomeComponent extends Component {
  render() {
    return (
      <div className='HomeComponent'>
        <div className='row mr-0'>
          <div className='col-md-12 py-5  d-flex flex-column justify-content-center'>
            <div className='row'>
              <div className='col-lg-6 col-md-8 mx-auto'>
                {/* <div className='card rounded shadow shadow-sm'> */}
                <div className='card-body'>
                  <div className='jumbotron'>
                    <h1 className='display-5'>
                      <b>Domotica casa Manno</b>
                    </h1>
                    <p className='lead'>by claudio</p>
                    <p>Catania</p>
                    <Link
                      // className='nav-link'
                      to='/login'
                      type='button'
                      name='home'
                      id='home'
                      className='btn btn-primary btn-lg'
                    >
                      Login
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      // </div>
    );
  }
}
